export enum SpotPricePeriod {
  '60M' = '60M',
  '15M' = '15M',
}

export enum SpotRegion {
  CZ = 'CZ',
  NL = 'NL',
  SK = 'SK',
}

export enum Currency {
  CZK = 'CZK',
  EUR = 'EUR',
}

export const SpotRegionCurrencyMap: Record<SpotRegion, Currency> = {
  [SpotRegion.CZ]: Currency.CZK,
  [SpotRegion.NL]: Currency.EUR,
  [SpotRegion.SK]: Currency.EUR,
};
